/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react'
import { FaYelp } from 'react-icons/fa'
import {
  TiSocialFacebookCircular,
  TiSocialPinterestCircular,
  TiSocialTwitterCircular,
  TiSocialYoutube,
} from 'react-icons/ti'
import { jsx } from 'theme-ui'
import { Flex } from './elements'
import config from '../../siteConfig'

const {
  social: { yelp, youtube, facebook, twitter },
} = config
export const Facebook = () => {
  return (
    <a target="_blank" rel="noopener noreferrer" href={facebook}>
      <TiSocialFacebookCircular />
    </a>
  )
}
export const Yelp = () => {
  return (
    <a target="_blank" rel="noopener noreferrer" href={yelp}>
      <FaYelp />
    </a>
  )
}
export const Twitter = () => {
  return (
    <a target="_blank" rel="noopener noreferrer" href={twitter}>
      <TiSocialTwitterCircular />
    </a>
  )
}
export const Pinterest = () => {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={config.social.pinterest || 'https://www.pinterest.com/phildibelloroofing/'}
    >
      <TiSocialPinterestCircular />
    </a>
  )
}
export const Youtube = () => {
  return (
    <a target="_blank" rel="noopener noreferrer" href={youtube}>
      <TiSocialYoutube />
    </a>
  )
}
export const Socials = ({ ...props }) => {
  return (
    <Flex sx={{ alignItems: 'space-evenly' }} {...props}>
      <Facebook />
      <Twitter />
      <Pinterest />
      <Youtube />
      <Yelp />
    </Flex>
  )
}
